var rich_content_viewer_default = {
  "fontElementMap": "THsMb",
  "wrapper": "t2sh6",
  "pluginContainerMobile": "JdSjs",
  "viewer": "N3pM5",
  "android": "KS3zs",
  "rootedTraversedContent": "Uy-gx",
  "atomic": "_0skFz",
  "toolbar": "_8b-XQ",
  "block": "kRdKI"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
